import { lazy } from "react";

export const Dashboard = lazy(() => import("../pages/Dashboard"));
export const Events = lazy(() => import("../pages/events/Events"));
export const EventCreate = lazy(() => import("../pages/events/EventCreate"));
export const EventUpdate = lazy(() => import("../pages/events/EventUpdate"));
export const Delegates = lazy(() => import("../pages/delegates/Delegates"));
export const DelegatesCreate = lazy(() =>
  import("../pages/delegates/DelegatesCreate")
);
export const DelegatesUpdate = lazy(() =>
  import("../pages/delegates/DelegatesUpdate")
);
export const Excels = lazy(() => import("../pages/excels/Excels"));
export const ExcelsCreate = lazy(() => import("../pages/excels/ExcelsCreate"));
export const ExcelsUpdate = lazy(() => import("../pages/excels/ExcelsUpdate"));
